import {
  BetweenHorizontalStart,
  ChartSpline,
  CreditCard,
  FileCode,
  GalleryThumbnails,
  Group,
  MonitorCog,
  Newspaper,
  Package,
  UserSearch,
  FileQuestion,
  User,
  History,
  BadgeDollarSignIcon,
} from "lucide-react";
import { Path } from "@app/route_path";

export interface MenuItem {
  icon?: any;
  path: Path;
  title: string;
  isActive?: boolean;
  // params?: Record<string, any>;
  items?: MenuItem[];
}

export const MainMenu: MenuItem[] = [
  {
    icon: ChartSpline,
    path: Path.DASHBOARD,
    title: "통계",
  },
  {
    icon: GalleryThumbnails,
    path: Path.WIDGET_INTEGRATION,
    title: "위젯 관리",
    items: [
      {
        icon: FileCode,
        path: Path.WIDGET_INTEGRATION,
        title: "연동하기",
      },
      {
        icon: MonitorCog,
        path: Path.WIDGET_SETTINGS,
        title: "세부 설정",
      },
      {
        icon: BetweenHorizontalStart,
        path: Path.WIDGET_EMBED,
        title: "위젯 스튜디오",
      },
    ],
  },
  {
    icon: Package,
    path: Path.POSTINGS,
    title: "포스팅 관리",
    items: [
      {
        icon: Package,
        path: Path.POSTINGS,
        title: "포스팅 목록",
      },
      {
        icon: Group,
        path: Path.POSTING_GROUPS,
        title: "포스팅 그룹 관리",
      },
    ],
  },
  {
    icon: Newspaper,
    path: Path.SHOP_SETTINGS,
    title: "쇼핑몰 정보",
  },
  {
    icon: UserSearch,
    path: Path.ACCOUNT_SETTINGS,
    title: "회원 정보",
  },
  {
    icon: BadgeDollarSignIcon,
    path: Path.PAYMENT_METHOD,
    title: "결제 관리",
    items: [
      {
        icon: CreditCard,
        path: Path.PAYMENT_METHOD,
        title: "결제 카드",
      },
      {
        icon: User,
        path: Path.PAYMENT_ADMIN,
        title: "결제 관리자",
      },
      {
        icon: History,
        path: Path.PAYMENT_HISTORY,
        title: "결제 내역",
      },
    ],
  },
  {
    icon: FileQuestion,
    path: Path.GUIDE,
    title: "가이드",
  },
];
